import { Capacitor } from "@capacitor/core";

/** True when running inside a Capacitor native shell (Android/iOS). */
export const isNativeApp = () => Capacitor.isNativePlatform();

/** 'ios' | 'android' | 'web' */
export const getPlatform = () => Capacitor.getPlatform();
